import { render, staticRenderFns } from "./newcontribute.vue?vue&type=template&id=60be67c6&scoped=true"
import script from "./newcontribute.vue?vue&type=script&lang=js"
export * from "./newcontribute.vue?vue&type=script&lang=js"
import style0 from "./newcontribute.vue?vue&type=style&index=0&id=60be67c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be67c6",
  null
  
)

export default component.exports